import { Cirus } from "@/classes/Http";

export function getDraftInvoice(instance_id: number, invoice_type: 'sold'|'bought') {
    const path = `/instance/${instance_id}/invoice/draft/${invoice_type}`;
    return Cirus.get(path);
}